import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { CHANGE_PASS } from "../../data/url";
import Alert from "../../utils/Alert";
import httpClient from "../../http/HttpRequest";

const ChangePass = (props) => {
  const { show, handleClose } = props;

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});

  const labelStyle = {fontSize:'small'};

  const closeModal = () => {
    handleClose(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
        
      setErrors(formErrors);
    } else {
      let payload = formData;
      const res = await httpClient.post(CHANGE_PASS, payload);     
      if (res.requestStatus === "OK") {
        const result = res.result;
        if (result.status === 1) {
          Alert.success(result.message);
          closeModal();
        } else {      
          Alert.error(result.message);
        }
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.old_password.trim()) {
      newErrors.old_password = "Old Password is required.";
    } else if (formData.old_password.trim().length < 8) {
      newErrors.old_password =
        "Old Password must be at least 8 characters long.";
    }

    if (!formData.new_password.trim()) {
      newErrors.new_password = "Password is required.";
    } else if (formData.new_password.trim().length < 8) {
      newErrors.new_password = "Password must be at least 8 characters long.";
    }

    if (!formData.confirm_password.trim()) {
      newErrors.confirm_password = "Confirm Password is required.";
    } else if (formData.confirm_password.trim().length < 8) {
      newErrors.confirm_password =
        "Confirm Password must be at least 8 characters long.";
    } else if (formData.confirm_password !== formData.new_password) {
      newErrors.confirm_password =
        "Confirm Password & New password should be same!";
    }
    return newErrors;
  };

  return (
    <Modal show={show} onHide={closeModal} keyboard={false} backdrop="static">
      <form className="pt-3" onSubmit={(e) => handleSubmit(e)}>
        <Modal.Header>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 mb-2">
            <label className="form-label" style={labelStyle}>Old Password</label>
            <input
              type="password"
              name="old_password"
              value={formData.old_password}
              onChange={handleChange}
              className="form-control"
              placeholder="Old password"
            
            />
            {errors.old_password && (
              <small className="text-danger">{errors.old_password}</small>
            )}
          </div>
          <div className="col-12 mb-2">
            <label className="form-label" style={labelStyle}>New Password</label>
            <input
              type="password"
              name="new_password"
              value={formData.new_password}
              onChange={handleChange}
              className="form-control"
              placeholder="New password"
            
            />
            {errors.new_password && (
              <small className="text-danger">{errors.new_password}</small>
            )}
          </div>
          <div className="col-12 mb-2">
            <label className="form-label" style={labelStyle}>Confirm Password</label>
            <input
              type="password"
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleChange}
              className="form-control"
              placeholder="Confirm password"
            
            />
            {errors.confirm_password && (
              <small className="text-danger">{errors.confirm_password}</small>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal} className="btn-sm">
            Close
          </Button>
          <Button variant="primary" type="submit" className="btn-sm">
            Change Password
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ChangePass;
